import { useQuery } from "@tanstack/react-query";
import {
  AnalyticsGranularity,
  getRegionUserAnalytics,
} from "../services/get-region-user-analytics";

export function useRegionUserAnalytics(
  id: string | undefined,
  days: number,
  granularity: AnalyticsGranularity,
) {
  return useQuery({
    queryKey: ["region", id, "user-analytics", days, granularity],
    queryFn: () => getRegionUserAnalytics(id as string, days, granularity),
    enabled: Boolean(id),
    staleTime: 1000 * 60 * 5,
  });
}
